import React from "react";

export const DriverDetailContext = React.createContext(null);

export const useDriverDetailContext = () => {
  const context = React.useContext(DriverDetailContext);

  if (!context) throw new Error("Driver Detail Context not provided!");

  return context;
};
